import MediaImage from "@/components/ui/MediaImage";
import { withRichTextRuleColours } from "@/utils/rich-text-rule";
import React, { useLayoutEffect, useRef, useState } from "react";
import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/sharp-solid-svg-icons";

interface FlexSectionTileProps {
  forceShowAll?: boolean;
  item: {
    imgurl?: string;
    overskrift: string;
    tekst: string;
    linktext: string;
    link: string;
  };
}

const FlexSectionRow: React.FC<FlexSectionTileProps> = ({
  item,
  forceShowAll,
}) => {
  const [showAll, setShowAll] = useState(forceShowAll ?? false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const descriptionRef = useRef<HTMLDivElement>(null);

  const checkOverflow = () => {
    if (descriptionRef.current) {
      setIsOverflowing(descriptionRef.current.clientHeight < 200);
    }
  };

  useLayoutEffect(() => {
    checkOverflow();
  }, []);

  return (
    <div className={`flex border bg-white ${showAll ? "" : "h-[200px]"}`}>
      <div className="relative w-1/3 lg:w-1/4">
        {item.imgurl && (
          <MediaImage
            src={item.imgurl}
            alt={`Slide`}
            className="w-full h-full inset-0 object-cover absolute"
          />
        )}
      </div>
      <div
        className={`flex flex-1 flex-col justify-between h-full ${showAll ? "" : "relative overflow-hidden"}`}
      >
        <div className="flex homepage-text-sm flex-col" ref={descriptionRef}>
          <div
            className={`flex flex-1 flex-col justify-between p-4 ${showAll ? "" : ""}`}
          >
            <div className="homepage-text-lg">{item.overskrift}</div>
            <div
              dangerouslySetInnerHTML={{
                __html: withRichTextRuleColours(item.tekst ?? ""),
              }}
            />
          </div>
          <div
            className={`p-4 ${showAll ? "" : "absolute bottom-0 pt-10 z-10 left-0 right-0 bg-gradient-to-b from-white/0 via-30% via-white/100 to-white/100"}`}
          >
            {!isOverflowing && (
              <button
                aria-label={showAll ? "Læs mindre" : "Læs mere"}
                onClick={() => setShowAll(!showAll)}
                className="flex w-full py-2 gap-1 items-center font-bold"
              >
                {showAll ? "Læs mindre" : "Læs mere"}
              </button>
            )}
            {item.link && (
              <Link
                className="font-bold gap-1 flex items-center"
                href={item.link}
              >
                {item.linktext ? item.linktext : item.link}
                <FontAwesomeIcon className="size-3" icon={faChevronRight} />
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlexSectionRow;
